'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-errors/ref.js
// module id = 244
// module chunks = 0 15 16 17 18